export default __webpack_public_path__ + "static/InstagramPreview-87a3e28cbe0063851cbb6c177f341078.png";